import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import DatePicker from "@/components/DatePicker";

export default function PersonalInfoStep({ data, set }) {
  const handle = (field) => (e) => set({ ...data, [field]: e.target.value });
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
      <div className="md:col-span-2">
        <Label htmlFor="full_name" className="text-forest">Full name</Label>
        <Input
          id="full_name"
          value={data.full_name || ""}
          onChange={handle("full_name")}
          required
          className="mt-1.5 h-11 border-line input-clean"
          data-testid="input-full-name"
        />
      </div>
      <div>
        <Label htmlFor="email" className="text-forest">Email</Label>
        <Input
          id="email"
          type="email"
          value={data.email || ""}
          onChange={handle("email")}
          required
          className="mt-1.5 h-11 border-line input-clean"
          data-testid="input-email"
        />
      </div>
      <div>
        <Label htmlFor="phone" className="text-forest">Phone</Label>
        <Input
          id="phone"
          value={data.phone || ""}
          onChange={handle("phone")}
          required
          className="mt-1.5 h-11 border-line input-clean"
          data-testid="input-phone"
        />
      </div>
      <div>
        <Label htmlFor="dob" className="text-forest">Date of birth</Label>
        <div className="mt-1.5">
          <DatePicker
            value={data.dob || ""}
            onChange={(v) => set({ ...data, dob: v })}
            placeholder="Pick your date of birth"
            testId="input-dob"
          />
        </div>
      </div>
      <div>
        <Label className="text-forest">Gender</Label>
        <Select value={data.gender || ""} onValueChange={(v) => set({ ...data, gender: v })}>
          <SelectTrigger className="mt-1.5 h-11 border-line" data-testid="select-gender">
            <SelectValue placeholder="Select" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="male">Male</SelectItem>
            <SelectItem value="female">Female</SelectItem>
            <SelectItem value="other">Other</SelectItem>
          </SelectContent>
        </Select>
      </div>
      <div>
        <Label htmlFor="id_number" className="text-forest">Government ID #</Label>
        <Input
          id="id_number"
          value={data.id_number || ""}
          onChange={handle("id_number")}
          required
          className="mt-1.5 h-11 border-line input-clean"
          data-testid="input-id-number"
        />
      </div>
      <div className="md:col-span-2">
        <Label htmlFor="address" className="text-forest">Street address</Label>
        <Input
          id="address"
          value={data.address || ""}
          onChange={handle("address")}
          required
          className="mt-1.5 h-11 border-line input-clean"
          data-testid="input-address"
        />
      </div>
      <div>
        <Label htmlFor="city" className="text-forest">City</Label>
        <Input
          id="city"
          value={data.city || ""}
          onChange={handle("city")}
          required
          className="mt-1.5 h-11 border-line input-clean"
          data-testid="input-city"
        />
      </div>
      <div>
        <Label htmlFor="state" className="text-forest">State</Label>
        <Input
          id="state"
          value={data.state || ""}
          onChange={handle("state")}
          required
          className="mt-1.5 h-11 border-line input-clean"
          data-testid="input-state"
        />
      </div>
      <div>
        <Label htmlFor="postal_code" className="text-forest">Postal code</Label>
        <Input
          id="postal_code"
          value={data.postal_code || ""}
          onChange={handle("postal_code")}
          required
          className="mt-1.5 h-11 border-line input-clean"
          data-testid="input-postal-code"
        />
      </div>
      <div className="md:col-span-2">
        <Label htmlFor="notes" className="text-forest">Anything we should know? <span className="text-sage font-normal">(optional)</span></Label>
        <Textarea
          id="notes"
          value={data.notes || ""}
          onChange={handle("notes")}
          rows={3}
          className="mt-1.5 border-line input-clean resize-none"
          data-testid="input-notes"
        />
      </div>
    </div>
  );
}
